import React, { useState } from 'react'

const Vardname = () => {
  // State for vard fields
  const [vardDetails, setVardDetails] = useState({
    vardName: '',
    vardNumber: ''
  });

  // State for storing all vards in table
  const [vardList, setVardList] = useState([]);

  // State for edit mode
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  // Handle Vard field changes
  const handleVardFieldChange = (field, value) => {
    setVardDetails(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (isEditing) {
      // Update existing entry
      const updatedList = [...vardList];
      updatedList[editIndex] = { ...vardDetails };
      setVardList(updatedList);
      setIsEditing(false);
      setEditIndex(null);
      alert('वर्ड अपडेट करण्यात आला!');
    } else {
      // Add new entry
      setVardList([...vardList, { ...vardDetails }]);
      alert('वर्ड सेव्ह करण्यात आला!');
    }
    
    // Reset form
    setVardDetails({
      vardName: '',
      vardNumber: ''
    });
  };

  // Handle form reset
  const handleReset = () => {
    setVardDetails({
      vardName: '',
      vardNumber: ''
    });
    setIsEditing(false);
    setEditIndex(null);
  };

  // Handle Edit
  const handleEdit = (index) => {
    setVardDetails({ ...vardList[index] });
    setIsEditing(true);
    setEditIndex(index);
  };

  // Handle Delete
  const handleDelete = (index) => {
    if (window.confirm('तुम्हाला हा वर्ड डिलीट करायचा आहे का?')) {
      const updatedList = vardList.filter((_, i) => i !== index);
      setVardList(updatedList);
      alert('वर्ड डिलीट करण्यात आला!');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 p-4 md:p-8">
      {/* Animated Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        <div className="absolute -top-20 -left-20 w-96 h-96 bg-gradient-to-r from-blue-200 to-indigo-200 rounded-full mix-blend-multiply opacity-20 animate-float"></div>
      </div>

      {/* Main Container */}
      <div className="relative z-10 max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-12 text-center">
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent mb-4">
            वर्ड व्यवस्थापन
          </h1>
          <div className="inline-block px-6 py-2 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-full border border-blue-200">
            <p className="text-lg font-medium text-blue-700">वर्ड तपशील भरा आणि व्यवस्थापित करा</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Side - Form */}
          <div className="relative">
            <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-48 h-2 bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 rounded-t-full blur-sm"></div>
            
            <div className="backdrop-blur-xl bg-white/95 rounded-3xl shadow-2xl border border-white/40 overflow-hidden h-fit">
              {/* Form Content */}
              <form onSubmit={handleSubmit} className="p-8 space-y-8">
                <div className="mb-6">
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
                    {isEditing ? 'वर्ड संपादित करा' : 'नवीन वर्ड जोडा'}
                  </h2>
                  <p className="text-sm text-gray-600">
                    {isEditing ? 'वर्डची माहिती संपादित करा' : 'नवीन वर्डची माहिती भरा'}
                  </p>
                </div>

                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-3">
                      <label className="block text-lg font-semibold text-gray-700">
                        वर्ड नाव
                      </label>
                      <input
                        type="text"
                        value={vardDetails.vardName}
                        onChange={(e) => handleVardFieldChange('vardName', e.target.value)}
                        placeholder="वर्डचे नाव टाइप करा"
                        className="w-full p-4 border-2 border-blue-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 focus:outline-none transition-all duration-300 text-lg"
                        required
                      />
                    </div>
                    
                    <div className="space-y-3">
                      <label className="block text-lg font-semibold text-gray-700">
                        वर्ड नंबर
                      </label>
                      <input
                        type="text"
                        value={vardDetails.vardNumber}
                        onChange={(e) => handleVardFieldChange('vardNumber', e.target.value)}
                        placeholder="वर्ड नंबर टाइप करा"
                        className="w-full p-4 border-2 border-blue-200 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-100 focus:outline-none transition-all duration-300 text-lg"
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row justify-center gap-6 pt-8">
                  <button
                    type="submit"
                    className="group relative px-8 py-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-bold rounded-2xl shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-blue-300 flex-1"
                  >
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-2xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="relative flex items-center justify-center space-x-3">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 group-hover:animate-bounce" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-lg">{isEditing ? 'अपडेट करा' : 'सेव्ह करा'}</span>
                    </div>
                  </button>
                  
                  <button
                    type="button"
                    onClick={handleReset}
                    className="group relative px-8 py-4 bg-gradient-to-r from-gray-500 to-gray-600 text-white font-bold rounded-2xl shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-gray-300 flex-1"
                  >
                    <div className="absolute inset-0 bg-gradient-to-r from-gray-600 to-gray-700 rounded-2xl blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="relative flex items-center justify-center space-x-3">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 group-hover:rotate-180 transition-transform duration-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                      </svg>
                      <span className="text-lg">{isEditing ? 'रद्द करा' : 'रिसेट करा'}</span>
                    </div>
                  </button>
                </div>
              </form>

              {/* Footer */}
              <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-t border-gray-200/50 py-4 px-8">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className="w-3 h-3 bg-gradient-to-r from-green-400 to-emerald-400 rounded-full animate-pulse"></div>
                    <span className="text-sm font-medium text-gray-600">
                      {isEditing ? 'संपादन मोड' : 'तयार'}
                    </span>
                  </div>
                  <span className="text-sm text-gray-500">
                    एकूण वर्ड: {vardList.length}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Table */}
          <div className="relative">
            <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-48 h-2 bg-gradient-to-r from-green-400 via-emerald-400 to-teal-400 rounded-t-full blur-sm"></div>
            
            <div className="backdrop-blur-xl bg-white/95 rounded-3xl shadow-2xl border border-white/40 overflow-hidden h-fit">
              {/* Table Header */}
              <div className="p-6 bg-gradient-to-r from-green-50 to-emerald-50 border-b border-green-100">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
                      वर्ड यादी
                    </h2>
                    <p className="text-sm text-gray-600">सर्व वर्डची यादी</p>
                  </div>
                  <div className="px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-xl">
                    <span className="font-bold text-lg">{vardList.length}</span>
                  </div>
                </div>
              </div>

              {/* Table Content */}
              <div className="p-6">
                {vardList.length === 0 ? (
                  <div className="text-center py-12">
                    <div className="inline-flex p-4 bg-gradient-to-r from-gray-100 to-gray-200 rounded-2xl mb-4">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                    <h3 className="text-xl font-semibold text-gray-600 mb-2">अद्याप कोणतेही वर्ड नाही</h3>
                    <p className="text-gray-500">वर्ड जोडण्यासाठी डाव्या बाजूला फॉर्म भरा</p>
                  </div>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="w-full">
                      <thead>
                        <tr className="bg-gradient-to-r from-blue-50 to-indigo-50">
                          <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700 border-b border-blue-100">क्र.</th>
                          <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700 border-b border-blue-100">वर्ड नाव</th>
                          <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700 border-b border-blue-100">वर्ड नंबर</th>
                          <th className="py-3 px-4 text-left text-sm font-semibold text-gray-700 border-b border-blue-100">क्रिया</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vardList.map((vard, index) => (
                          <tr 
                            key={index} 
                            className={`hover:bg-gradient-to-r hover:from-blue-50/50 hover:to-indigo-50/50 transition-colors duration-200 ${
                              index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'
                            }`}
                          >
                            <td className="py-3 px-4 border-b border-gray-100">
                              <div className="flex items-center">
                                <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-r from-blue-500 to-indigo-500 text-white rounded-lg font-bold">
                                  {index + 1}
                                </div>
                              </div>
                            </td>
                            <td className="py-3 px-4 border-b border-gray-100">
                              <div className="font-medium text-gray-800">{vard.vardName}</div>
                            </td>
                            <td className="py-3 px-4 border-b border-gray-100">
                              <div className="font-medium text-gray-800">{vard.vardNumber}</div>
                            </td>
                            <td className="py-3 px-4 border-b border-gray-100">
                              <div className="flex items-center space-x-2">
                                <button
                                  onClick={() => handleEdit(index)}
                                  className="group relative p-2 bg-gradient-to-r from-blue-100 to-blue-200 hover:from-blue-200 hover:to-blue-300 rounded-lg transition-all duration-300"
                                  title="संपादित करा"
                                >
                                  <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 relative" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                  </svg>
                                </button>
                                <button
                                  onClick={() => handleDelete(index)}
                                  className="group relative p-2 bg-gradient-to-r from-red-100 to-red-200 hover:from-red-200 hover:to-red-300 rounded-lg transition-all duration-300"
                                  title="डिलीट करा"
                                >
                                  <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-red-600 rounded-lg blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-600 relative" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                  </svg>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

              {/* Table Footer */}
              <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-t border-gray-200/50 py-4 px-8">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">
                    {vardList.length === 0 ? 'कोणतेही डेटा नाही' : `एकूण ${vardList.length} वर्ड`}
                  </span>
                  {vardList.length > 0 && (
                    <button
                      onClick={() => {
                        if (window.confirm('तुम्हाला सर्व वर्ड डिलीट करायचे आहेत का?')) {
                          setVardList([]);
                          alert('सर्व वर्ड डिलीट करण्यात आले!');
                        }
                      }}
                      className="px-4 py-2 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white text-sm font-medium rounded-lg transition-all duration-300"
                    >
                      सर्व क्लियर करा
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add custom animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0) rotate(0deg);
          }
          33% {
            transform: translateY(-20px) rotate(120deg);
          }
          66% {
            transform: translateY(20px) rotate(240deg);
          }
        }
        
        .animate-float {
          animation: float 20s infinite ease-in-out;
        }
      `}</style>
    </div>
  )
}

export default Vardname